import { axiosWithAuth } from "helpers";
import { ZendeskTicketType } from "types";

export const zendeskService = {
	addZendeskTicket,
	getZendeskLink,
};

const API_URL = process.env.REACT_APP_API_URL;

function getZendeskLink(type, id) {
	window.open(`${API_URL}/api/links/zendesk/${type}/${id}`, "_blank");
}

function addZendeskTicket({
	data,
	applicationId,
}: {
	data: ZendeskTicketType;
	applicationId: string;
}) {
	return axiosWithAuth({
		method: "POST",
		data,
		url: `${API_URL}/api/underwriting/qa/applications/${applicationId}/create_ticket`,
	});
}
